globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Controllers = appCustomerSpace.Controllers || {};
appCustomerSpace.Controllers.LocalManagement = appCustomerSpace.Controllers.LocalManagement || {};

appCustomerSpace.Controllers.LocalManagement.GeneralController = (function(superClass) {

    utils.extend(GeneralController, superClass);

    function GeneralController() {
        return GeneralController.__super__.constructor.apply(this, arguments);
    }

    $.extend(GeneralController.prototype, {
        init: function(){
            if($("input#find_address").length){
                this._initAddress();
            }
            this._initServiceArea();

            return GeneralController.__super__.init.apply(this, arguments);
        },
        _initAddress: function(){
            var $form = $('form.location-informations-form'),
            $btnChangeAddress = $form.find('.btn-change-address');
            $inputGeocoder = $form.find("input#find_address");

            var setGmapHeight = function() {
                $('#accounts_business_location_address_map').css('height', $('#address-text-components')[0].offsetHeight + 'px')
            }

            setGmapHeight();

            $btnChangeAddress.on('click', function(){
                $btnChangeAddress.closest('.form-group').find('.edit-address-fields').toggle().find('input').first().focus();
            });

            $form.find('#accounts_business_location_address_line_2').on('change', function(){
                $form.find('[data-address-component="line_2"]').html($(this).val())
            });

            $inputGeocoder.addresspicker({
                apiKey: helpers.google.api.key,
                elements: {
                    map: '#accounts_business_location_address_map',
                    lat: '#accounts_business_location_address_latitude',
                    lng: '#accounts_business_location_address_longitude',
                    postal_code: '#accounts_business_location_address_postal_code',
                    locality: '#accounts_business_location_address_city_name',
                    country: '#accounts_business_location_address_country',
                    country_code: '#accounts_business_location_address_region_code'
                },
                mapOptions: { zoom: 15 },
                draggableMarker: !$inputGeocoder.prop('disabled'),
                reverseGeocode: !$inputGeocoder.prop('disabled'),
                updateCallback: function(geocodeResult, parsedGeocodeResult) {
                    var address_line_1 = [];
                    if(parsedGeocodeResult.street_number) address_line_1.push(parsedGeocodeResult.street_number);
                    if(parsedGeocodeResult.route) address_line_1.push(parsedGeocodeResult.route);

                    $form.find("#accounts_business_location_address_line_1").val(address_line_1.join(" "));

                    Object.keys(parsedGeocodeResult).forEach(function(key) {
                        var $addressComponent = $form.find('[data-address-component='+ key +']');
                        if($addressComponent.length) {
                            $addressComponent.html(parsedGeocodeResult[key])
                        }
                    });

                    setGmapHeight()
                }
            });
        },
        _initServiceArea: function(){
            var $secondaryBusinessActivitiesContainer = $('.secondary-business-activities-container'),
                $selectMainBusinessActivityWrapper    = $('.select-main-business-activity-wrapper');

            $secondaryBusinessActivitiesContainer.on('click', '.delete-secondary-business-activity', function(e) {
                e.preventDefault();
                var $formGroup = $(this).closest('.form-group');

                $formGroup.find('input.secondary-business-activity-destroy-input').val(true);
                $formGroup.hide();
            });

            $selectMainBusinessActivityWrapper.on('click', '.main_business_activity_input', function() {
                $selectMainBusinessActivityWrapper.find('.open-modal').trigger('click');
            });

            var $serviceAreaCitiesContainer = $('.service-area-cities-container'),
                $ServiceAreaCityWrapper     = $('.service-area-city-wrapper');

            $serviceAreaCitiesContainer.on('click', '.delete-service-area-city', function(e) {
                e.preventDefault();
                var $formGroup = $(this).closest('.form-group');

                $formGroup.find('input.service-area-city-destroy-input').val(true);
                $formGroup.hide();

                if ($serviceAreaCitiesContainer.find('.form-group:visible').length < 11 ) {
                    $serviceAreaCitiesContainer.find('.cities-count-alert').hide();
                }
            });

            if ($ServiceAreaCityWrapper != undefined) {
                $('.service-at-customer-location-checkbox').on('click', 'input[type=checkbox]', function() {
                    var $checkbox = $(this);
                    if ($checkbox.is(':checked')) {
                        $ServiceAreaCityWrapper.show();
                    } else {
                        $ServiceAreaCityWrapper.hide();
                    }
                });
            }
        }
    });

    return GeneralController;

})(appCustomerSpace.Controllers.LocalManagement.MainController);
